import { render, staticRenderFns } from "./novelinfo-add-or-update.vue?vue&type=template&id=76dfc1e2"
import script from "./novelinfo-add-or-update.vue?vue&type=script&lang=js"
export * from "./novelinfo-add-or-update.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports